import Menu from 'Models/Menu';

export default [
  Menu.recordCreate,
  Menu.directoryCreate,
  // Menu.assetInformation,
  Menu.assetEdit,
  Menu.assetDelete,
  // Menu.assetClone,
  // Menu.assetAlert,
  Menu.searchAsset,
  Menu.assetsHelp,
];
